<template>
  <div class="main">
    <div class="dropzone-container rounded w-100"
         @dragover="dragOver"
         @dragleave="dragLeave"
         @drop="drop">
      <input type="file"
             name="file"
             id="fileInput"
             class="hidden-input"
             @change="onChange"
             ref="file"
             accept=".jpg"/>

      <label for="fileInput"
             class="file-label">
        <div v-if="isDragging">
          {{ $t('DropZone.releaseFiles') }}
        </div>
        <div v-else>
          {{ $t('DropZone.dropFilesHere') }} <u>{{ $t('DropZone.clickHere') }}</u> {{ $t('DropZone.toUpload') }}
        </div>
      </label>

      <div class="preview-container mt-4  justify-content-center"
           v-if="files.length">
        <div class="preview-cart"
             v-for="file in files"
             :key="file.name">
          <div>
            <img class="preview-image"
                 alt="Preview"
                 :src="generateTmpURL(file)">
            <p>{{ file.name }}</p>
          </div>
          <div>
            <button class="preview-remove-btn rounded ml-3"
                    type="button"
                    @click="remove(files.indexOf(file))"
                    title="Remove file">
              <strong>x</strong>
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>

</template>

<script>
import {sharedState} from "@/store";
import {postUserImage} from "@/utils";

export default {
  data() {
    return {
      isDragging: false,
      files: [],
      message: '',
      messageType: '',
    };
  },
  methods: {
    onChange() {
      this.files.push(...this.$refs.file.files);
    },
    dragOver(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    dragLeave() {
      this.isDragging = false;
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(fileIndex) {
      this.files.splice(fileIndex, 1);
    },
    generateTmpURL(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
    async uploadFile() {
      if (this.files.length > 0) {
        const data = new FormData();
        this.files.forEach((file) => {
          data.append("image", file);
        })
        let response = await postUserImage(sharedState.user_id, data);
        if (response.status === 200) {
          this.message = response.data.message;
          this.messageType = "success";
        } else {
          this.message = response.response.data.message;
          this.messageType = "danger";
        }
        this.files.pop();
      }
    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.dropzone-container {
  padding: 1rem;
  background: #E7DBC0;
  border: 3px dashed #1A4B35;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 1em;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 1rem;
}

.preview-cart {
  display: flex;
  border: 2px solid #63432A;
  padding: 6px;
  margin-left: 6px;
}

.preview-image {
  width: 100px;
  height: 100px;
  border-radius: 50px;
  border: 1px solid #63432A;
  background-color: #63432A;
}

.preview-remove-btn {
  border: 1px solid #63432A;
  background-color: #E7DBC0;
  color: #1A4B35;
}
</style>